module.exports = "//static.hsappstatic.net/HubspotToolsMenu/static-1.640/css/toolsmenu.css"